import type { CellContext, ColumnDef } from '@tanstack/react-table';
import type { TFunction } from 'i18next';
import type { JSX } from 'react';
import React from 'react';

import type { SegmentExport } from '@feathr/blackbox';
import type { ITanStackColumnMeta } from '@feathr/components';

import ExportRowActions from './ExportRowActions';

/**
 * Row-actions column, pinned right so the kebab stays reachable while the data columns scroll.
 *
 * Hand-written rather than built by `createActionMenuColumn`: that factory owns the menu and takes
 * only the items to put inside it, while `ExportRowActions` owns its own `ContextMenu` together
 * with the Stop and Archive confirmation modals those items open.
 */
const optionsColumn = (t: TFunction): ColumnDef<SegmentExport> => ({
  cell: ({ row }: CellContext<SegmentExport, unknown>): JSX.Element => (
    <ExportRowActions record={row.original} />
  ),
  enableResizing: false,
  enableSorting: false,
  header: t('Options'),
  id: 'options',
  meta: { align: 'center', pinned: 'right' } satisfies ITanStackColumnMeta,
  size: 80,
});

export default optionsColumn;
